export default "__VITE_ASSET__DUhkE6v$__"